import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';

import { TimePicker, DatePicker } from 'material-ui-pickers';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';

import {stableSort, getSorting} from '../Common/helpers';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import ModalBox from '../Common/Modals/ModalBox';

import { API } from '../../ws/constants';

class AddEditOrder extends Component {
    /* START Constructor */
    constructor(props) {
        super(props);

        this.state = {
            orderId:this.props.props.match.params.id
            ,order:'asc'
            ,orderBy:'Name'
            ,page:0
            ,rowsPerPage:5
            ,openModal: false
            ,editable: false
            ,returnTitle: "Erro"
            ,returnText: "Ocorreu algum erro"
            ,returnType: 1
            ,itemData: null
            ,orderData: null
            ,storeId: ""
            ,storeName: ""
            ,storeShortname: ""
            ,storeColor: ""
            ,paymentConditionId: 0
            ,paymentType: ""
            ,paymentTypeName: ""
            ,paymentTypeImage: ""
            ,staffId: ""
            ,staffFirstName: ""
            ,staffLastName: ""
            ,clientId: ""
            ,clientFirstName: ""
            ,clientLastName: ""
            ,clientContact: ""
            ,clientFinance: ""
            ,originalTotal: 0
            ,totalValue: 0
            ,discount: 0
            ,discountPercentage: 0
            ,orderDate: null
            ,notes: ""
            ,isCanceled: 0
            ,jobTypes: []
            ,fetchJobTypes: null
            ,fetchPaymentConditions: null
        };
    }

    /* END Constructor */

    /* START React own Functions */

    componentDidMount() {
        const { orderId } = this.state;
        const fetches = [
            fetch(API + 'getorders&getbyid=' + orderId)
            , fetch(API + 'getjobtypes')
            , fetch(API + 'getpaymentconditions')
        ];

        Promise.all(fetches)
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then(result => {
            const orderData = result[0].data;
            
            if(result === null || result.shortmsg === "NOK"){
                this.props.props.history.push('/Orders');
                return;
            }
            
            this.setState({ 
                itemData: result[0].itemData
                ,orderData: orderData
                ,orderId: orderData.OrderId
                ,storeId: orderData.StoreId
                ,storeName: orderData.StoreName
                ,storeShortname: orderData.StoreShortname
                ,storeColor: orderData.StoreColor
                ,paymentConditionId: orderData.PaymentCondition
                ,paymentType: orderData.PaymentType
                ,paymentTypeName: orderData.PaymentTypeName
                ,paymentTypeImage: orderData.PaymentTypeImage
                ,staffId: orderData.StaffId
                ,staffFirstName: orderData.StaffFirstName
                ,staffLastName: orderData.StaffLastName
                ,clientId: orderData.ClientId
                ,clientFirstName: orderData.ClientFirstName
                ,clientLastName: orderData.ClientLastName
                ,clientContact: orderData.ClientContact
                ,clientFinance: orderData.ClientFinance
                ,originalTotal: orderData.OriginalTotal
                ,totalValue: orderData.TotalWithVat
                ,discount: orderData.Discount
                ,discountPercentage: orderData.DiscountPercentage
                ,orderDate: orderData.DateCreated
                ,notes: orderData.Notes
                ,isCanceled: orderData.IsCanceled
                ,jobTypes: orderData.JobTypes.split(",")
                ,fetchJobTypes: result[1].data
                ,fetchPaymentConditions: result[2].data
            });                
        });
    }

    /* END React own Functions */

    /* START Handles */

    handleSelectChange = (e) => this.setState({ [e.target.name]: e.target.value, somethingWasEdited:true });
    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });

    handleOrderDateInputChange = (value) => {
        this.setState({ orderDate: value });
    }

    handleOrderTimeInputChange = (value) => {
        this.setState({ orderTime: value });
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    /* END Handles */

    /* START Component Functions */

    openModal = (textObj) => {
        this.setState({ returnTitle: textObj.title, returnText: textObj.text , openModal: true });
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }

    /* END Component Functions */

    /* START Renders */

    renderPaymentConditionsOptions = (e) => {
        const paymentConditions = this.state.fetchPaymentConditions;
        if(paymentConditions===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=paymentConditions.length;i<n;i++) {
            items.push(<MenuItem value={paymentConditions[i].Id}
                                 checked={this.state.paymentConditionId && this.state.paymentConditionId.indexOf(paymentConditions[i].Id) > -1}
                                 className="insetItem multipleItem"
                                 key={paymentConditions[i].Id}>{paymentConditions[i].Name}</MenuItem>);
        }
        return items;
    }

    renderJobTypesOptions = (e) => {
        const jobTypes = this.state.fetchJobTypes;
        if(jobTypes===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=jobTypes.length;i<n;i++) {
            items.push(<MenuItem value={jobTypes[i].Id}
                                 checked={this.state.jobTypes && this.state.jobTypes.indexOf(jobTypes[i].Id) > -1}
                                 className="insetItem multipleItem"
                                 key={jobTypes[i].Id}>{jobTypes[i].Shortname + " - " + jobTypes[i].Name}</MenuItem>);
        }
        return items;
    }

    render() {
        const { isAdmin, loginData } = this.props;      
        const { editable } = this.state
        , itemData = this.state.itemData!=null ? this.state.itemData : []
        , orderData = this.state.orderData!=null ? this.state.orderData : []
        , { order, orderBy, rowsPerPage, page } = this.state
        , paymentConditions = this.renderPaymentConditionsOptions()
        , optsJobTypes = this.renderJobTypesOptions()
        , headerRows = [
            { id: 'Name', active: true, numeric: false, label: 'Nome' },
            { id: 'ItemPrice', numeric: false, label: 'Preço' },
            { id: 'ItemDiscount', numeric: false, label: 'Desconto' },
            { id: 'ItemTaxPercentage', numeric: false, className: 'smallerHeader', label: 'IVA' },
            { id: 'ItemQuantity', numeric: false, className: 'smallerHeader', label: 'Qtd.' },
            { id: 'ItemTotalWithVat', numeric: false, label: 'Total' },
            { id: 'ItemType', numeric: false, className: 'smallerHeader', label: 'Tipo' },
            { id: 'actions', notSortable: true, label: 'Ações' },
        ]     
        ,loadingClass = this.state.loading ? " ajaxLoading" : ""
        ,totalWithoutItemDiscounts = (parseFloat(this.state.totalValue) + parseFloat(this.state.discount)).toFixed(2);    

        return (
            <div id="viewEditOrders" className={"addEditPage" + loadingClass}>
                <div ref="editForm" className="form">
                    <div className="row">
                        <div className="col-12">
                            <h1><i className="fa fa-cash-register"></i> Compra ({this.state.orderId})
                                { (isAdmin || loginData.profile.Clients.isActive) && 
                                    <span className="float-right">
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    id="isCanceled"
                                                    checked={!!+this.state.isCanceled}
                                                    disabled={!(isAdmin || (loginData.profile.Cart.DEL.permission === 1 && editable))}
                                                    onChange={this.handleToggle}
                                                    color="primary"/>
                                            }
                                            label="Cancelar Compra"/>
                                    </span>
                                }
                                { (isAdmin || loginData.profile.Clients.canPrint) && 
                                    <span className="float-right printHolder">
                                        <NavLink type="button" className="simpleBtn actionButton success" to={{pathname:"/PrintOrder/" + this.state.clientId}} target="_blank" title="Imprimir ficha de cliente">Imprimir <i className="fa fa-print fa-2x"></i></NavLink>
                                    </span>
                                }
                            </h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-12">
                            <div className="row">
                                <h3 className="fieldHolder col-12">Informação do Cliente&nbsp; 
                                    <Tooltip
                                        title="Ver Cliente"
                                        enterDelay={200}>
                                        <span className="arrayCount">
                                                <NavLink type="button" className="simpleBtn actionButton" to={{pathname:"/Clients/" + orderData.ClientId}} target="_blank">({orderData.ClientFullName})</NavLink>                                   
                                        </span>
                                    </Tooltip>
                                    {
                                        orderData.ClientGlobalNotes && (isAdmin || loginData.profile.Clients.globalNotes) &&
                                        <Tooltip
                                            title={orderData.ClientGlobalNotes}
                                            enterDelay={200}>
                                            <span><button className="simpleBtn danger globalNotesWarning" onClick={() => this.openModal({ title: "Notas do Cliente", text: orderData.ClientGlobalNotes })}><i className="far fa-sticky-note"></i></button></span>
                                        </Tooltip>
                                    }
                                    </h3>
                                <div className="fieldHolder col-md-3">
                                    <TextField fullWidth
                                               id="clientFirstName"
                                               value={this.state.clientFirstName}
                                               onChange={this.handleFieldChange}
                                               label="Primeiro Nome"
                                               disabled={!editable}
                                               data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder col-md-3">
                                    <TextField fullWidth
                                               id="clientLastName"
                                               value={this.state.clientLastName}
                                               onChange={this.handleFieldChange}
                                               label="Último Nome"
                                               disabled={!editable}
                                               data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder col-md-3">
                                    <TextField fullWidth
                                               id="clientCellPhone"
                                               value={this.state.clientCellPhone}
                                               onChange={this.handleFieldChange}
                                               label="Telefone"
                                               disabled={!editable}
                                               data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder col-md-3">
                                    <TextField fullWidth
                                               id="clientFinanceNumber"
                                               value={this.state.clientFinanceNumber}
                                               onChange={this.handleFieldChange}
                                               label="NIF"
                                               disabled={!editable}
                                               data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-12">
                            <div className="row">
                                <h3 className="fieldHolder col-12">Informação do Funcionário&nbsp;
                                        <Tooltip
                                            title="Ver Funcionário"
                                            enterDelay={200}>
                                            <span className="arrayCount">
                                                <NavLink type="button" className="simpleBtn actionButton" to={{pathname:"/Staff/" + orderData.StaffId}} target="_blank">({orderData.StaffFullName})</NavLink>
                                            </span>
                                        </Tooltip>
                                </h3>
                                <div className="fieldHolder col-md-3">
                                    <TextField fullWidth
                                               id="staffFirstName"
                                               value={this.state.staffFirstName}
                                               onChange={this.handleFieldChange}
                                               label="Primeiro Nome"
                                               disabled={!editable}
                                               data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder col-md-3">
                                    <TextField fullWidth
                                               id="staffLastName"
                                               value={this.state.staffLastName}
                                               onChange={this.handleFieldChange}
                                               label="Último Nome"
                                               disabled={!editable}
                                               data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder col-md-6">
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="jobTypes">Funções</InputLabel>
                                        <Select id="jobTypes"
                                                name="jobTypes"
                                                multiple
                                                value={this.state.jobTypes}
                                                onChange={this.handleSelectChange}
                                                disabled={!editable}
                                                data-empty-error-message="Este campo não pode estar vazio">
                                            {optsJobTypes}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="fieldHolder col-md-12">
                            <div className="row">
                                <h3 className="fieldHolder col-12">Informação da Compra</h3>
                                <div className="fieldHolder col-md-4">
                                    <div className="fieldImageHolder"><div className="storeColorHolder" style={{backgroundColor: this.state.storeColor}}></div></div>   
                                    <TextField fullWidth
                                            id="store"
                                            value={this.state.storeName + " - " + this.state.storeShortname}
                                            onChange={this.handleFieldChange}
                                            label="Loja"
                                            disabled={!editable}
                                            data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder col-md-4">
                                    <div className="fieldImageHolder"><img src={this.state.paymentTypeImage} alt={this.state.paymentTypeName} /></div>                                        
                                    <TextField fullWidth
                                            id="paymentType"
                                            value={this.state.paymentTypeName}
                                            onChange={this.handleFieldChange}
                                            label="Método"
                                            disabled={!editable}
                                            data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder col-md-4">
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="paymentConditionId">Condição de Pagamento</InputLabel>
                                        <Select id="paymentConditionId"
                                                name="paymentConditionId"
                                                value={this.state.paymentConditionId}
                                                onChange={this.handleSelectChange}
                                                disabled={!editable}
                                                data-empty-error-message="Este campo não pode estar vazio">
                                        {paymentConditions}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            <div className="row">
                                <div className="fieldHolder col-md-2">
                                    <DatePicker
                                        fullWidth
                                        id="orderDate"
                                        label="Data"
                                        format="DD/MM/YYYY"
                                        disabled={!editable}
                                        value={this.state.orderDate || null}
                                        locale="pt-PT"
                                        onChange={this.handleOrderDateInputChange}
                                    />
                                </div>
                                <div className="fieldHolder col-md-2">
                                    <TimePicker
                                        fullWidth={true}
                                        id="orderTime"
                                        label="Hora da compra"
                                        value={this.state.orderDate || null}
                                        onChange={this.handleOrderTimeInputChange}
                                        ampm={false}
                                        format="HH:mm:ss"
                                        disabled={!editable}
                                        InputLabelProps={{
                                            shrink: true,
                                        }} />
                                </div>
                                <div className="fieldHolder moneyHolder col-md-2">
                                    <TextField fullWidth
                                            id="originalTotal"
                                            value={parseFloat(this.state.originalTotal).toFixed(2)}
                                            onChange={this.handleFieldChange}
                                            label="Valor Original"
                                            disabled={!editable}
                                            data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder moneyHolder col-md-2">
                                    <TextField fullWidth
                                            id="totalWithoutItemDiscounts"
                                            value={parseFloat(totalWithoutItemDiscounts).toFixed(2)}
                                            onChange={this.handleFieldChange}
                                            label="Sem Descontos"
                                            disabled={!editable}
                                            data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder moneyHolder col-md-2">
                                    <TextField fullWidth
                                            id="discount"
                                            value={parseFloat(this.state.discount).toFixed(2) + " ("+this.state.discountPercentage+"%)"}
                                            onChange={this.handleFieldChange}
                                            label="Desconto"
                                            disabled={!editable}
                                            data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                                <div className="fieldHolder moneyHolder col-md-2">
                                    <TextField fullWidth
                                            id="totalValue"
                                            value={parseFloat(this.state.totalValue).toFixed(2)}
                                            onChange={this.handleFieldChange}
                                            label="Valor Final"
                                            disabled={!editable}
                                            data-empty-error-message="Este campo não pode estar vazio" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="fieldHolder col-md-12">
                                    <TextField fullWidth
                                            id="notes"
                                            value={this.state.notes}
                                            onChange={this.handleFieldChange}
                                            disabled={!editable}
                                            multiline
                                            rows={4}
                                            label="Observações" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="fieldHolder col-md-12">
                            <div className="row">
                                <h3 className="fieldHolder col-12">Informação dos Items</h3>
                                <div className="tableHolder col-12">
                                    <div className="tableHeader">
                                        <h2><i className="fa fa-clipboard-list"></i> Items <span className="arrayCount">({orderData.TotalItems})</span></h2>
                                    </div>
                                    <Table className={"responsiveTable customTable originalTable" + loadingClass}>
                                        <EnhancedTableHead
                                            className="tableRow tableHeader"
                                            headerRows={headerRows}
                                            order={order}
                                            orderBy={orderBy}
                                            onRequestSort={this.handleRequestSort}
                                            rowCount={itemData.length}>
                                        </EnhancedTableHead>
                                        <TableBody>
                                            {stableSort(itemData, getSorting(order, orderBy))
                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                .map(item =>
                                            <TableRow key={item.ItemId} className="tableRow" ref={"item_" + item.ItemId}>
                                                <TableCell data-title="Nome" className="tableCell">{item.ProductName}</TableCell>
                                                <TableCell data-title="Preço" className="tableCell">
                                                    {parseFloat(item.ItemPriceWithoutVat).toFixed(2) + "€"}                                                        
                                                </TableCell>
                                                <TableCell data-title="Desconto" className="tableCell">
                                                    {parseFloat(item.ItemDiscount).toFixed(2) + "€ (" + item.ItemDiscountPercentage + "%)" }                                                        
                                                </TableCell>
                                                <TableCell data-title="IVA" className="tableCell">
                                                    {item.ItemVatPercentage + "%"}                                                        
                                                </TableCell>
                                                <TableCell data-title="Qtd." className="tableCell smallerCell">{item.ItemQuantity}</TableCell>
                                                <TableCell data-title="Total" className="tableCell">
                                                    {parseFloat(item.ItemTotalWithVat).toFixed(2) + "€"}                                                        
                                                </TableCell>
                                                <TableCell data-title="Tipo" className="tableCell smallerCell">{item.ItemTypeName}</TableCell>
                                                <TableCell data-title="Ações" className="tableCell actions" data-row-id={item.ItemId}>
                                                    <Tooltip
                                                        title={"Ver Item"}
                                                        enterDelay={200}>
                                                        <span><NavLink type="button" className="simpleBtn actionButton success" to={{pathname:"/Products/" + item.ItemId}} target="_blank"><i className="fa fa-eye"></i></NavLink></span>
                                                    </Tooltip>
                                                    {/* <Tooltip
                                                        title={"Eliminar Item"}
                                                        enterDelay={200}>
                                                        <button type="button" className="simpleBtn actionButton danger" onClick={() => this.deleteItemRow(item.ItemId)}><i className="fa fa-times"></i></button>
                                                    </Tooltip> */}
                                                </TableCell>
                                            </TableRow>
                                            )}
                                            {   this.state.discount && 
                                                <TableRow key={"discount"} className="tableRow" ref={"item_discount"}>
                                                    <TableCell data-title="Nome" className="tableCell">Desconto</TableCell>
                                                    <TableCell data-title="Preço" className="tableCell">---</TableCell>
                                                    <TableCell data-title="Desconto" className="tableCell">---</TableCell>
                                                    <TableCell data-title="IVA" className="tableCell">---</TableCell>
                                                    <TableCell data-title="Qtd." className="tableCell smallerCell">1</TableCell>
                                                    <TableCell data-title="Total" className="tableCell">
                                                        {"-" + parseFloat(this.state.discount).toFixed(2) + "€ ("+this.state.discountPercentage+"%)"}                                                        
                                                    </TableCell>
                                                    <TableCell data-title="Tipo" className="tableCell smallerCell">Desconto</TableCell>
                                                    <TableCell data-title="Ações" className="tableCell actions" data-row-id={"discount"}>
                                                    </TableCell>
                                                </TableRow>
                                            }
                                            <TableRow key={"total"} className="tableRow" ref={"item_total"}>
                                                <TableCell data-title="Nome" className="tableCell">Total</TableCell>
                                                <TableCell data-title="Preço" className="tableCell">---</TableCell>
                                                <TableCell data-title="Desconto" className="tableCell">---</TableCell>
                                                <TableCell data-title="IVA" className="tableCell">---</TableCell>
                                                <TableCell data-title="Qtd." className="tableCell smallerCell">---</TableCell>
                                                <TableCell data-title="Total" className="tableCell">
                                                    {parseFloat(this.state.totalValue).toFixed(2) + "€"}                                                       
                                                </TableCell>
                                                <TableCell data-title="Tipo" className="tableCell smallerCell">Total</TableCell>
                                                <TableCell data-title="Ações" className="tableCell actions" data-row-id={"total"}>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </div>
                                <div className="col-12">
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={itemData.length}
                                        rowsPerPage={rowsPerPage}
                                        labelRowsPerPage="Linhas por página:"
                                        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                                        page={page}
                                        backIconButtonProps={{
                                            'aria-label': 'Página anterior',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Próxima página',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </div>
                            </div>
                        </div>                                
                    </div>
                    <div className="row">
                        <div className="col-12 buttonsHolder">
                            <Button onClick={this.props.props.history.goBack} variant="contained" className="defaultButton">Voltar</Button>
                            { editable && <Button onClick={this.handleSave} className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                        </div>
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default AddEditOrder;
